export default __webpack_public_path__ + "static/media/illustration-stay-productive.5d7a50ea.png";